import React        from 'react';
import PropTypes    from 'prop-types';
import Translations from '../../../utils/Translations';

class LikesCountLabel extends React.Component {
	render() {
		if (this.props.likes === 0) {
			return null;
		}

		return (this.props.asIcon)
			? (
				<span className="video-grid__item--label" title={this.props.likes}>
					<i className="icon -icon-like-full">&nbsp;</i>
					{this.props.short}
				</span>
			)
			: (
				<span className="video-grid__item--label --inverse" title={this.props.likes}>
					{Translations.get('VideoGridLikes').replace(':likes', this.props.short)}
				</span>
			);
	}
}

LikesCountLabel.propTypes = {
	likes:  PropTypes.number,
	short:  PropTypes.string,
	asIcon: PropTypes.bool,
};

LikesCountLabel.defaultProps = {
	likes:  0,
	short:  '0',
	asIcon: false,
};

export default LikesCountLabel;